import { Autoevaluacion } from '../_modules/estudio/autoevaluacion/autoevaluacion';
import {Evento} from './evento';
import { GoogleClass } from './googleClassroom/google-class';

export class EventoUnidad{
    id: number;
    unidad: any;
    unidadID: number;
    evento: Evento;
    eventoID: number;
    eventoMaterias: any;
    recursos: any;
    metas: any;
    isActive: boolean;
    isDeleted: boolean;
    isEditable: boolean;
    categoriaID: number;
    comentariosNuevos: number;
    retroalimentacionPorcentaje: number;
    autoevaluaciones: Autoevaluacion[];

    constructor(eventoUnidad: {
        id: number,
        unidad: any,
        unidadID: number,
        evento: Evento,
        eventoID: number,
        eventoMaterias?: any,
        recursos?: any,
        metas?: any,
        isActive: boolean,
        isDeleted: boolean,
        isEditable: boolean,
        comentariosNuevos?: number,
        retroalimentacionPorcentaje?: number,
        autoevaluaciones?: Autoevaluacion[];
    }) {
        this.id = eventoUnidad.id;
        this.unidad = eventoUnidad.unidad;
        this.unidadID = eventoUnidad.unidadID;
        this.evento = eventoUnidad.evento;
        this.eventoID = eventoUnidad.eventoID;
        this.eventoMaterias = eventoUnidad.eventoMaterias || [];
        this.recursos = eventoUnidad.recursos || [];
        this.metas = eventoUnidad.metas || [];
        this.isActive = eventoUnidad.isActive;
        this.isDeleted = eventoUnidad.isDeleted;
        this.isEditable = eventoUnidad.isEditable;
        this.categoriaID = eventoUnidad.evento.categoriaID;
        this.comentariosNuevos = eventoUnidad.comentariosNuevos || 0;
        this.retroalimentacionPorcentaje = eventoUnidad.retroalimentacionPorcentaje || 0;
        this.autoevaluaciones = eventoUnidad.autoevaluaciones || [];
    }
}
